import { JSONParser } from "@amcharts/amcharts5";
import { showAlert, openInfoWindow } from "../helpers";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import $ from "jquery";

import Swiper from "swiper";
import { Pagination, EffectFade } from "swiper/modules";
// import Swiper and modules styles
import "swiper/css";
// import "swiper/css/pagination";
import "swiper/css/effect-fade";

// let markers = [];
let map;
const recruitmentMessage = "Not yet enrolling participants";
const cluster_svg = window.btoa(`
    <svg fill="#F79547" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
    <circle cx="120" cy="120" opacity="1" r="70" />
    <circle cx="120" cy="120" opacity=".7" r="90" />
    <circle cx="120" cy="120" opacity=".3" r="110" />
    <circle cx="120" cy="120" opacity=".2" r="130" />
    </svg>`);

function hasMapContainer() {
    return document.getElementById("map") instanceof HTMLElement;
}

function getActiveSites() {
    if (!hasMapContainer()) return;

    let markers = [];

    $.ajax({
        type: "POST",
        url: "/api/sites",
        contentType: "application/json",
        success(res) {
            // console.log(res);

            if (res.matches !== undefined) {
                let infowindows = [];

                // render map...
                // center @ Lebanon, Kansas (the geographic center of the usa)
                // https://en.wikipedia.org/wiki/Geographic_center_of_the_United_States#:~:text=The%20answer%20of%20Lebanon%2C%20Kansas%20is%20accepted%20as%20correct.
                map = new google.maps.Map(document.getElementById("map"), {
                    center: new google.maps.LatLng(
                        39.8105749082469,
                        -98.55555553203541
                    ),
                    // center: new google.maps.LatLng(-34.397, 150.644),
                    zoom: 4,
                });

                // matches
                $.each(res.matches, function (key, matchedSite) {
                    // populate site infowindow...
                    let infoWindowTemplate = $("#infowindow-template").clone();
                    infoWindowTemplate.find("h3.name").html(matchedSite.name);
                    infoWindowTemplate
                        .find(".address_1")
                        .html(matchedSite.address_1);

                    if (matchedSite.address_2) {
                        infoWindowTemplate
                            .find(".address_2")
                            .html(", " + matchedSite.address_2)
                            .removeClass("hidden");
                    }

                    infoWindowTemplate.find(".city").html(matchedSite.city);
                    infoWindowTemplate
                        .find(".territory")
                        .html(matchedSite.territory);
                    infoWindowTemplate
                        .find(".postal_code")
                        .html(matchedSite.postal_code);
                    infoWindowTemplate
                        .find(".country_code")
                        .html(matchedSite.country_code);

                    if (matchedSite.active == false) {
                        infoWindowTemplate
                            .find(".recruitment")
                            .html(recruitmentMessage);
                    }

                    infoWindowTemplate
                        .find(".site-listing-link")
                        .attr("data-site-id", matchedSite.id);

                    let infoHTML = $("<div />")
                        .append(
                            infoWindowTemplate
                                .clone()
                                .removeClass("template")
                                .attr("id", "siteinfowindow-" + key)
                        )
                        .html();

                    const infoWindow = new google.maps.InfoWindow({
                        content: infoHTML,
                    });

                    google.maps.event.addListener(
                        infoWindow,
                        "domready",
                        function () {
                            $(".site-listing-link").on("click", (e) => {
                                getSiteData(e.target.dataset.siteId).then(
                                    (res) => {
                                        loadSingleSiteCard(res);
                                    }
                                );
                            });
                        }
                    );

                    const marker = new google.maps.Marker({
                        position: {
                            lat: parseFloat(matchedSite.latitude),
                            lng: parseFloat(matchedSite.longitude),
                        },
                        map: map,
                        title: matchedSite.name,
                    });

                    markers.push(marker);
                    // console.log(marker);
                    marker.addListener("click", () => {
                        openInfoWindow(map, marker, infoWindow);
                    });
                });

                // localStorage.setItem("infowindows", infowindows);
                $("#search-results").css("display", "block");
            }

            const renderer = {
                render: ({ count, position }) =>
                    new google.maps.Marker({
                        icon: {
                            url: `data:image/svg+xml;base64,${cluster_svg}`,
                            scaledSize: new google.maps.Size(45, 45),
                        },
                        label: {
                            text: String(count),
                            color: "white",
                            fontSize: "14px",
                            fontWeight: "bold",
                        },
                        position,
                        // adjust zIndex to be above other markers
                        zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                    }),
            };

            new MarkerClusterer({ map, markers, renderer });
        },
        error(xhr, status, err) {
            showAlert(xhr.responseJSON.error);
        },
    });
}

// function removeMarkers() {
//     //Loop through all the markers and remove
//     for (var i = 0; i < markers.length; i++) {
//         markers[i].setMap(null);
//     }
//     markers = [];
// }

function search(data) {
    if (!hasMapContainer()) return;

    let total_sites = 0;

    // console.log(data);

    // removeMarkers();
    $("#search-results-header").hide();
    $("#search-swiper .swiper-wrapper").html("");
    $("#noresults").hide();
    $("#single-result").html("").addClass("hidden");
    $("#singl-result-message").hide();
    let markers = [];

    $.ajax({
        type: "POST",
        url: "/api/sites/search",
        data: JSON.stringify(data),
        contentType: "application/json",
        success(res) {
            // console.log(res);
            if (res.search !== undefined) {
                let infowindows = [];
                let newSlide = null;
                let all_sites = [];

                // $("#all-sites").hide();
                // user
                const searchLat = res.search.geometry.location.lat;
                const searchLng = res.search.geometry.location.lng;
                const searchLocation = {
                    lat: searchLat,
                    lng: searchLng,
                };

                // render map
                // map.setCenter(searchLocation);
                // map.setZoom(8);
                map = new google.maps.Map(document.getElementById("map"), {
                    center: searchLocation,
                    zoom: 8,
                });

                $.each(res.groups, function (idx, group) {
                    let sites = JSONParser.parse(group.sites);
                    total_sites += sites.length;

                    $.each(sites, function (key, matchedSite) {
                        all_sites.push(matchedSite);
                    });
                });

                const sorted_by_distance = all_sites.sort(function (a, b) {
                    return a.distance - b.distance;
                });

                let pages = [];
                const chunkSize = 6;
                for (let i = 0; i < sorted_by_distance.length; i += chunkSize) {
                    const chunk = sorted_by_distance.slice(i, i + chunkSize);
                    pages.push(chunk);
                }

                if (pages.length > 0) {
                    if (pages.length > 1) {
                        $(".swiper-nav").css("display", "flex");
                    }
                    $("#search-swiper").show();

                    $("#search-swiper .swiper-wrapper").html("");

                    let center_marker = null;
                    $.each(pages, function (key, sites) {
                        newSlide = document.createElement("div");
                        newSlide.classList.add("swiper-slide");

                        $.each(sites, function (key, matchedSite) {
                            let groupEl = $("#result-group-template").clone();
                            groupEl.removeClass("template");
                            groupEl
                                .find(".group-name")
                                .html(matchedSite.territory);
                            $(groupEl).attr("id", "sitegroup-" + key);

                            //removes the display none style for the at-home card

                            $("#site-home").removeAttr("id");
                            $("#site-home-card").removeAttr("id");
                           

                            // populate site infowindow...
                            let infoWindowTemplate = $("#infowindow-template")
                                .clone()
                                .removeClass("template");

                            infoWindowTemplate
                                .find("h3.name")
                                .html(matchedSite.name);

                            infoWindowTemplate
                                .find(".site-listing-link")
                                .attr("data-site-id", matchedSite.id);

                            infoWindowTemplate
                                .find(".address_1")
                                .html(matchedSite.address_1);
                            if (matchedSite.address_2) {
                                infoWindowTemplate
                                    .find(".address_2")
                                    .html(", " + matchedSite.address_2)
                                    .removeClass("hidden");
                            }
                            infoWindowTemplate
                                .find(".city")
                                .html(matchedSite.city);
                            infoWindowTemplate
                                .find(".territory")
                                .html(matchedSite.territory);
                            infoWindowTemplate
                                .find(".postal_code")
                                .html(matchedSite.postal_code);
                            infoWindowTemplate
                                .find(".country_code")
                                .html(matchedSite.country_code);

                            if (matchedSite.active == false) {
                                infoWindowTemplate
                                    .find(".recruitment")
                                    .html(recruitmentMessage);
                            }
                            let addressHTML = infoWindowTemplate
                                .find(".site-address")
                                .clone()
                                .removeClass("template")
                                .html();

                            let infoHTML = $("<div />")
                                .append(
                                    infoWindowTemplate
                                        .clone()
                                        .removeClass("template")
                                        .attr("id", "siteinfowindow-" + key)
                                )
                                .html();

                            const infoWindow = new google.maps.InfoWindow({
                                content: infoHTML,
                            });

                            google.maps.event.addListener(
                                infoWindow,
                                "domready",
                                function () {
                                    $(".site-listing-link").on("click", (e) => {
                                        getSiteData(
                                            e.target.dataset.siteId
                                        ).then((res) => {
                                            loadSingleSiteCard(res);
                                        });
                                    });
                                }
                            );

                            // create map marker
                            const marker = new google.maps.Marker({
                                position: {
                                    lat: matchedSite.latitude,
                                    lng: matchedSite.longitude,
                                },
                                map: map,
                                title: matchedSite.name,
                            });
                            marker.addListener("click", () => {
                                openInfoWindow(map, marker, infoWindow);
                            });

                            markers.push(marker);

                            if (!center_marker) center_marker = marker;

                            // populate card info...
                            let card = $("#result-card-template")
                                .clone()
                                .removeClass("template");

                            card.attr("id", "sitecard-" + key);
                            card.find(".card-subtitle").html(
                                "Site ID: " +
                                    matchedSite.identifier.toUpperCase() +
                                    "<br>Distance: " +
                                    Number.parseFloat(
                                        matchedSite.distance
                                    ).toFixed(2) +
                                    "mi."
                            );
                            card.find(".card-title").html(matchedSite.name);
                            card.find(".card-text").html(addressHTML);
                            card.find(".card-title").on("click", function (e) {
                                e.preventDefault();
                                openInfoWindow(map, marker, infoWindow);
                            });

                            if (matchedSite.active == false) {
                                card.find(".recruitment").html(
                                    recruitmentMessage
                                );
                            }

                            let investigators = JSONParser.parse(
                                matchedSite.investigators
                            );

                            $.each(
                                investigators,
                                function (key3, investigator) {
                                    // console.log(investigator);
                                    let investEl = $(
                                        "#result-investigator-template"
                                    )
                                        .clone()
                                        .removeClass("template");
                                    investEl.attr(
                                        "id",
                                        "siteinvestigator-" + key3
                                    );
                                    investEl
                                        .find(".name")
                                        .html(
                                            "Investigator: " + investigator.name
                                        );

                                    investEl.appendTo(
                                        card.find(".card-investigators")
                                    );
                                }
                            );

                            // populate contacts
                            let contacts = JSONParser.parse(
                                matchedSite.contacts
                            );
                            $.each(contacts, function (key, contact) {
                                let contactEl = $("#result-contact-template")
                                    .clone()
                                    .removeClass("template");
                                contactEl.attr("id", "sitecontact-" + key);
                                contactEl.find(".name").html(contact.name);
                                contactEl.find(".phone").html(contact.phone);
                                contactEl
                                    .find(".email_text")
                                    .html(contact.email);
                                contactEl
                                    .find(".email a")
                                    .attr(
                                        "href",
                                        "mailto:" +
                                            contact.email +
                                            "?subject=Inquiring about the TEMPO study"
                                    );
                                contactEl.appendTo(card.find(".card-contacts"));
                            });
                            // card.appendTo(wrapper);
                            $(groupEl).prependTo(card);
                            

                            $(card).appendTo(newSlide);
                        });
                        $(newSlide).appendTo("#search-swiper .swiper-wrapper");
                    });

                    const renderer = {
                        render: ({ count, position }) =>
                            new google.maps.Marker({
                                icon: {
                                    url: `data:image/svg+xml;base64,${cluster_svg}`,
                                    scaledSize: new google.maps.Size(45, 45),
                                },
                                label: {
                                    text: String(count),
                                    color: "white",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                },
                                position,
                                // adjust zIndex to be above other markers
                                zIndex:
                                    Number(google.maps.Marker.MAX_ZINDEX) +
                                    count,
                            }),
                    };
                    new MarkerClusterer({ map, markers, renderer });

                    $("#search-results-header").css("display", "flex");
                    $("#single-result-message").hide();
                    $("#results-message").show();
                    $("#total-sites").html(total_sites);
                    $("#site-search-container").removeClass("hidden");

                    // localStorage.setItem("infowindows", infowindows);

                    map.setCenter(center_marker.getPosition());
                    map.setZoom(10);
                    // setTimeout(function () {
                    //     $("html,body").animate(
                    //         { scrollTop: $("#search-results").offset().top },
                    //         "slow"
                    //     );
                    // }, 100);
                } else {
                    $("#noresults").show();
                }
            }
        },
        error(xhr, status, err) {
            console.log(status);
            showAlert(xhr.responseJSON.error);
        },
    });
}

// site search
$("#site-search-form").on("submit", (e) => {
    e.preventDefault();

    const data = {
        address: $("#search-query").val().trim(),
        // radius: parseFloat($("#search-radius").val().trim()),
    };

    // $("#sites-list").html(null);
    // $("#sites-list").addClass("active");
    $("#site-search-container").addClass("hidden");

    search(data);
});

// on document ready
$(document).ready(function () {
    if (!hasMapContainer()) return;

    // create map

    getActiveSites();

    // reset search results
    $("#reset-search-results").on("click", function () {
        $("#search-query").val("");
        // $("#sites-list").html(null);
        // $("#sites-list").removeClass("active");
        $("#site-search-container").addClass("hidden");
        $("#search-swiper .swiper-wrapper").html("");
        $("#single-result").html("");
        $("#singl-result-message").hide();
        $(".swiper-nav").hide();

        $("#search-results-header").hide();
        // getActiveSites();
        // removeMarkers();
        // map.setCenter({ lat: 39.8105749082469, lng: -98.55555553203541 });
        // map.setZoom(4);
        getActiveSites();

        setTimeout(function () {
            $("html,body").animate(
                { scrollTop: $("#site-search-form").offset().top },
                "slow"
            );
        }, 100);

        // $("#all-sites").show();
    });

    const swiper = new Swiper("#search-swiper", {
        effect: "fade",
        allowTouchMove: false,
        on: {
            slideChangeTransitionEnd: function () {
                const show_start = this.realIndex;
                // console.log(show_start);
                const show_end = show_start * 6 + 6;

                $("#show_start").html(show_start * 6 + 1);
                $("#show_end").html(show_end);
            },
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                return `<span class="dot swiper-pagination-bullet">${
                    index + 1
                }</span>`;
            },
        },

        modules: [Pagination, EffectFade],
    });
});

/**
 * Get data for a single site
 *
 * @param {*} site_id
 * @return {*}
 */
async function getSiteData(site_id) {
    const response = await fetch("/api/site/" + site_id);
    const result = await response.json();
    return result;
}

/**
 * Show single-result information
 *
 * @param {*} data
 */
function loadSingleSiteCard(data) {
    $("#search-results-header").css("display", "flex");
    $("#results-message").hide();
    $("#single-result-message").show();
    $("#single-message").html(data.site.name);

    $(".swiper-nav").hide();
    $("#search-swiper").hide();

    let groupEl = $("#result-group-template").clone();
    groupEl.removeClass("template");
    groupEl
        .find(".group-name")
        .html(data.territory_name ? data.territory_name : data.site.territory);
    $(groupEl).attr("id", "single-sitegroup");

    let card = $("#result-card-template").clone().removeClass("template");

    let infoWindowTemplate = $("#infowindow-template")
        .clone()
        .removeClass("template");
    let address = infoWindowTemplate.find(".site-address").clone();

    address.find(".address_1").html(data.site.address_1);
    if (data.site.address_2) {
        address
            .find(".address_2")
            .html(", " + data.site.address_2)
            .removeClass("hidden");
    }

    address.find(".city").html(data.site.city);
    address.find(".territory").html(data.site.territory);
    address.find(".postal_code").html(data.site.postal_code);
    address.find(".country_code").html(data.site.country_code);

    card.attr("id", "single-sitecard");
    card.find(".card-subtitle").html(
        "Site ID: " +
            data.site.identifier.toUpperCase() +
            "<br>Distance: " +
            Number.parseFloat(data.site.distance).toFixed(2) +
            "mi."
    );
    card.find(".card-title").html(data.site.name);
    card.find(".card-text").html(address.html());
    card.find(".card-title").on("click", function (e) {
        e.preventDefault();
        openInfoWindow(map, marker, infoWindow);
    });

    if (data.site.active == false) {
        card.find(".recruitment").html(recruitmentMessage);
    }

    let investigators = JSONParser.parse(data.investigators);
    $.each(investigators, function (idx, investigator) {
        // console.log(investigator);
        let investEl = $("#result-investigator-template")
            .clone()
            .removeClass("template");
        investEl.attr("id", "single-siteinvestigator-" + idx);
        investEl.find(".name").html("Investigator: " + investigator.name);

        investEl.appendTo(card.find(".card-investigators"));
    });

    // populate contacts
    let contacts = JSONParser.parse(data.contacts);
    $.each(contacts, function (idx, contact) {
        let contactEl = $("#result-contact-template")
            .clone()
            .removeClass("template");
        contactEl.attr("id", "single-sitecontact-" + idx);
        contactEl.find(".name").html(contact.name);
        contactEl.find(".phone").html(contact.phone);
        contactEl.find(".email_text").html(contact.email);
        contactEl
            .find(".email a")
            .attr(
                "href",
                "mailto:" +
                    contact.email +
                    "?subject=Inquiring about the TEMPO study"
            );
        contactEl.appendTo(card.find(".card-contacts"));
    });

    let single = document.getElementById("single-result");
    single.innerHTML = "";

    $(groupEl).prependTo(card);
    $(card).appendTo(single);

    $("#single-result").removeClass("hidden");
    $("#search-swiper").css("visisbility", "hidden");
    $("#site-search-container").removeClass("hidden");

    if (document.fullscreenElement) {
        document.exitFullscreen();
    } else if (document.mozFullScreenElement) {
        document.mozCancelFullScreen();
    } else if (document.webkitFullscreenElement) {
        document.webkitExitFullscreen();
    } else if (document.msFullscreenElement) {
        document.msExitFullscreen();
    }

    setTimeout(function () {
        $("html,body").animate(
            { scrollTop: $("#search-results").offset().top },
            "slow"
        );
    }, 100);
}
